import {
  parseChapters,
  parseHighlights,
  parseCoachingResponse,
} from "@app/analytics/MeetingReport/api/parsingUtils";
import type { CoachingDataWithoutTimestamps } from "@app/analytics/MeetingReport/types";
import { get } from "@app/common/api";
import apiClient from "@app/common/api/apiClient";
import type {
  ApiChapter,
  BaseSessionChapter,
  BaseSessionHighlight,
  CoachingApiResponse,
} from "@app/common/types";

export const getSessionHighlights = async (
  sessionId: string
): Promise<BaseSessionHighlight[]> => {
  const clips = await apiClient.session.clips.getClips(sessionId);
  return parseHighlights(clips);
};

export const getSessionChapters = async (
  sessionId: string
): Promise<BaseSessionChapter[]> => {
  const json: ApiChapter[] = await get(`/sessions/${sessionId}/chapters`, {
    withCreds: true,
  });

  return parseChapters(json);
};

export const getCoachingData = async (
  sessionId: string,
  userId: string
): Promise<CoachingDataWithoutTimestamps> => {
  const json: CoachingApiResponse = await get(
    `/metrics/coaching?session_id=${sessionId}&user_id=${userId}`,
    { withCreds: true }
  );

  return parseCoachingResponse(json);
};
